import type { MouseEventHandler } from 'react';
import React from 'react';

const CloseIcon: React.FC<{
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
}> = ({ width = 14, height = 14, className = '', onClick, fill = 'black' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.928547 0.928875C0.603111 1.25431 0.60311 1.78195 0.928547 2.10739L6.82116 8L0.928549 13.8926C0.603112 14.2181 0.603113 14.7457 0.92855 15.0711C1.25399 15.3966 1.78162 15.3966 2.10706 15.0711L7.99967 9.17851L13.8922 15.071C14.2176 15.3964 14.7452 15.3964 15.0707 15.071C15.3961 14.7456 15.3961 14.2179 15.0707 13.8925L9.17819 8L15.0707 2.1075C15.3961 1.78207 15.3961 1.25443 15.0707 0.928992C14.7452 0.603555 14.2176 0.603555 13.8922 0.928992L7.99967 6.82149L2.10706 0.928875C1.78162 0.603438 1.25398 0.603438 0.928547 0.928875Z"
      fill={fill}
    />
  </svg>
);

export default CloseIcon;
